import { atom } from "../app-jotai";

export interface User {
  id: string;
  username: string;
  email: string;
  isAdmin: boolean;
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

// Main auth state atom
export const authStateAtom = atom<AuthState>({
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: true, // Start as loading to check for existing session
  error: null,
});

// Derived atoms for convenience
export const userAtom = atom((get) => get(authStateAtom).user);

export const isAuthenticatedAtom = atom(
  (get) => get(authStateAtom).isAuthenticated,
);

export const isAdminAtom = atom(
  (get) => get(authStateAtom).user?.isAdmin ?? false,
);

export const isLoadingAtom = atom((get) => get(authStateAtom).isLoading);

export const authErrorAtom = atom((get) => get(authStateAtom).error);

// Login dialog state
export const loginDialogStateAtom = atom<{
  isOpen: boolean;
  step: "username" | "mfa" | null;
  username: string;
}>({
  isOpen: false,
  step: null,
  username: "",
});

// Admin dialog state
export const adminDialogStateAtom = atom<{
  isOpen: boolean;
}>({
  isOpen: false,
});

// Add/Edit user dialog state
export const userDialogStateAtom = atom<{
  isOpen: boolean;
  mode: "add" | "edit";
  userId: string | null;
}>({
  isOpen: false,
  mode: "add",
  userId: null,
});
